import * as colors from "../constants/colors";
import { css, StyleSheet } from "aphrodite";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";

const styles = StyleSheet.create({
	container: {
		border: `1px solid ${colors.gray2}`,
		color: colors.black4,
		backgroundColor: colors.white,
		height: 25,
		width: 25,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		fontSize: 20,
	},
	priori: {
		fontFamily: "priori-sans",
	},
});

export default class AccordianOpenIndicator extends PureComponent {
	static propTypes = {
		isOpen: PropTypes.bool,
		toggleOpen: PropTypes.func.isRequired,
	};

	render() {
		return (
			<button
				onClick={this.props.toggleOpen}
				className={css([styles.container, /*!this.props.isOpen && */ styles.priori])}
			>
				{this.props.isOpen ? "-" : "+"}
			</button>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/AccordianOpenIndicator.js